import React from "react"
import { Text, SimpleGrid, Flex, Box } from "@chakra-ui/react"
import type { VariantTrialType } from "@shared/graphql.types"
import { colours } from "@shared/ui.design-system"
import Markdown from "markdown-to-jsx"
import { fonts } from "theme/themeConfig"

type Props = {
  trials: VariantTrialType
}

export const TrialResults: React.FC<Props> = ({
  trials: { results, trialResults, sourceOfTrialResults, title },
}) => {
  const fontProps = { base: 5, md: 8 }

  return (
    <>
      <Box
        maxW="100%"
        m={0}
        id="results"
        scrollMarginTop={{ base: "110px", lg: "150px" }}
      >
        {title && (
          <Text
            variant="apercu"
            my="1.5rem"
            fontSize={{ base: "1.25rem", md: 9 }}
          >
            {title}
          </Text>
        )}

        {trialResults && (
          <Text variant="acuminLight" mt={{ base: 0, lg: 1 }}>
            {trialResults}
          </Text>
        )}
      </Box>
      <SimpleGrid
        columns={{ base: 1, lg: 2 }}
        maxW={{ base: "100%", lg: "35rem" }}
        spacingX={{ base: "unset", lg: 7 }}
        spacingY={{ base: 1, lg: 4 }}
      >
        {results?.map((result) => (
          <Flex key={result?.value} flexDir="column">
            <Flex alignItems="flex-end">
              <Text
                color={colours.primary.dark}
                fontFamily={fonts.acuminMedium}
                letterSpacing="0.04em"
                fontSize={fontProps}
                lineHeight={fontProps}
              >
                {result?.label?.replace(/%/g, "")}
              </Text>
              <Text
                color={colours.primary.dark}
                fontFamily={fonts.acuminLight}
                letterSpacing="0.04em"
                fontSize={fontProps}
                lineHeight={fontProps}
              >
                %
              </Text>
            </Flex>

            {!!result?.value && (
              <Markdown
                as="span"
                options={{
                  overrides: {
                    span: {
                      component: Text,
                      props: {
                        variant: "acuminLight",
                        mt: 0,
                        as: "span",
                      },
                    },
                    p: {
                      component: Text,
                      props: {
                        variant: "acuminLight",
                        mt: 0,
                      },
                    },
                  },
                }}
              >
                {result?.value}
              </Markdown>
            )}
          </Flex>
        ))}
      </SimpleGrid>
      {sourceOfTrialResults && (
        <Text variant="acuminLight" mt={{ base: 3, lg: 7 }}>
          {sourceOfTrialResults}
        </Text>
      )}
    </>
  )
}
